import { render, staticRenderFns } from "./EndpointCard.vue?vue&type=template&id=50d54e4b&scoped=true&"
import script from "./EndpointCard.vue?vue&type=script&lang=js&"
export * from "./EndpointCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d54e4b",
  null
  
)

export default component.exports